import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import * as apiUrl from "../../apiUrl";

function CollectionBanner() {
  const [CollectionBanner, setCollectionBanner] = useState([]);

  useEffect(() => {
    const fetchCollectionBanner = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/collection/banner-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setCollectionBanner(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCollectionBanner();
  }, []);

  return (
    <div
      className="common-banner-sec"
      style={{
        backgroundImage: `url(${apiUrl.apiUrl + `/` + CollectionBanner.banner_image
          })`,
      }}
    >
      <Container fluid>
        <Row className="banner-text-center">
          <Col md={4}>
            <div className="banner-text-topspace">
              <h1 className="common-head darkGrey">
                {CollectionBanner.banner_title}
              </h1>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CollectionBanner;
